import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Zone } from 'src/app/domain/zone';
import { ZoneService } from 'src/app/services/zone.service';
import { ZoneTerrainService } from 'src/app/services/zone-terrain.service';
import { NotificationManager } from '../notification-manager';


@Component({
    selector: 'change-process-box',
    templateUrl: 'change-zone-box.html',
    styleUrls: ['./change-zone-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeZoneDialog implements OnInit {

    private interventionCode: string;
    zoneSource: Zone;
    ZoneList: Zone[] = [];
    SelectedZone!: Zone;

    constructor(
        private snackbar: MatSnackBar,
        private zoneService: ZoneService,
        private zoneTerrainService: ZoneTerrainService,
        public dialogRef: MatDialogRef<ChangeZoneDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.interventionCode = data.interventionCode;
        this.zoneSource = data.zoneSource;
    }

    ngOnInit() {
        // Zone from GS
        this.zoneService.getZoneList(this.interventionCode).subscribe(x => {
            this.ZoneList = x.filter(x => x.Usage === this.zoneSource.Usage && x.Name !== this.zoneSource.Name);
        })
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {

        this.zoneTerrainService.changeZone(this.interventionCode, this.zoneSource.Code, this.SelectedZone.Id).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Zone modifiée', this.snackbar);
                this.dialogRef.close(x);
            }
        })
    }
}
